<template>
  <div class="subscribe">
    <!-- <div class="current-box">111</div> -->
    <div class="current-box">
      <div class="section">
        <div class="search">
          <span class="label-top">当前订阅</span>
          <!-- @click="exportDeviceDetail()" -->
          <button class="button-export">
            <!-- {{$t('report.Export_report')}} -->
            新增订阅
            <!-- <i class="iconfont icon-export"></i> -->
            <i class="ico-base ico-add"></i>
          </button>
        </div>
        <!-- v-loading="isLoading" -->
        <el-table class="tablemain tableloding" element-loading-spinner="el-icon-loading" height="100%" stripe border
          :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" :data="subscribeList">
          <!-- :empty-text="$t('message.nodata')" -->
          <!-- :label="$t('rate.datalogger_pn')" -->
          <el-table-column prop="rule" min-width="130px" :show-overflow-tooltip="true" label="规则名称"></el-table-column>
          <el-table-column prop="emailTitle" min-width="90px" :show-overflow-tooltip="true" label="邮件标题">
          </el-table-column>
          <el-table-column prop="device" min-width="90px" :show-overflow-tooltip="true" label="导出设备">
          </el-table-column>
          <el-table-column prop="email" min-width="90px" :show-overflow-tooltip="true" label="收件邮箱">
          </el-table-column>
          <el-table-column prop="type" min-width="90px" :show-overflow-tooltip="true" label="报表类型">
          </el-table-column>
          <el-table-column prop="dimension" min-width="90px" :show-overflow-tooltip="true" label="时间维度">
          </el-table-column>
          <el-table-column prop="startTime" min-width="90px" :show-overflow-tooltip="true" label="订阅开始时间">
          </el-table-column>
          <el-table-column prop="language" min-width="90px" :show-overflow-tooltip="true" label="报表语言">
          </el-table-column>
          <!-- :label="$t('rate.operating')" -->
          <!-- <el-table-column 
            prop="Operation" 
            fixed="right" 
            width="100px" 
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                class="operation"
                :title="$t('rate.edit')"
                @click="edit(scope.row)"
              >
                <i class="iconfont icon-edit"></i>
              </el-button>
            </template>
          </el-table-column> -->
          <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png" />
            <div style="line-height: 32px">{{ $t('account.nodata') }}</div>
          </div>
        </el-table>
        <!-- 分页 -->
        <!-- <div class="tablebottom">
          <el-pagination
            v-show="paginationControl"
            class="pagination"
            background
            @size-change="getData(true)"
            @current-change="()=>getData()"
            :current-page.sync="pagination.currentPage"
            :page-sizes="[10,20,30,50]"
            :page-size.sync="pagination.pagesize"
            layout="slot, sizes, total, pager, prev, next"
            :total="pagination.total"
            popper-class="select-page-recharge"
          >
            <span style="color:#ffffff;padding-left:15px;">{{$t('device.pageSize')}} :</span>
          </el-pagination>
        </div> -->
      </div>
      <!-- 编辑设备 -->
      <!-- :title="$t('rate.edit')" :visible.sync="editVisible" v-if="editVisible" -->
      <sub-dialog v-if="false">
        <div slot="content">
          编辑弹窗内容
        </div>
        <div slot="footer">
          <!-- <button class="button-hollow" @click="editVisible = false">{{$t('rate.cancel')}}</button> -->
          <button class="button-solid" @click="submitEdit">{{ $t('rate.confirm') }}</button>
        </div>
      </sub-dialog>
    </div>
    <div class="history-box">
      <div class="section">
        <div class="search">
          <span class="label-top" v-show="!showSearch">邮件历史</span>
          <!-- 搜索 -->
          <el-button v-show="!showSearch" icon="el-icon-search" class="button-search"
            @click="showSearch = true;"></el-button>
          <div class="search-alert" v-show="showSearch">
            <!-- v-model.trim="search.search" -->
            <!-- @keyup.enter.native="getDeviceList(true)" -->
            <!-- :placeholder="this.$t('device.Sn_deviceName')" -->
            <el-input v-model="inputText" placeholder="" clearable>
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <span class="search-hide" @click="showSearch = false;">取消</span>
          </div>

          <!-- @click="exportDeviceDetail()" -->
          <button class="button-export">
            <!-- {{$t('report.Export_report')}} -->
            清除历史
            <!-- <i class="iconfont icon-export"></i> -->
            <i class="ico-base ico-clear"></i>
          </button>
        </div>
        <!-- v-loading="isLoading" -->
        <el-table class="tablemain tableloding" element-loading-spinner="el-icon-loading" height="100%" stripe border
          :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" :data="subscribeList">
          <!-- :empty-text="$t('message.nodata')" -->
          <!-- :label="$t('rate.datalogger_pn')" -->
          <el-table-column prop="emailTitle" min-width="90px" :show-overflow-tooltip="true" label="邮件标题">
          </el-table-column>
          <el-table-column prop="email" min-width="90px" :show-overflow-tooltip="true" label="收件邮箱">
          </el-table-column>
          <el-table-column prop="sendTime" min-width="90px" :show-overflow-tooltip="true" label="发送时间">
          </el-table-column>
          <div v-show="emptyText" slot="empty"><img src="@/assets/img/empty_text.png" />
            <div style="line-height: 32px">{{ $t('account.nodata') }}</div>
          </div>
        </el-table>
        <!-- 分页 -->
        <!-- <div class="tablebottom">
          <el-pagination
            v-show="paginationControl"
                        class="pagination"
                        background
            @size-change="getData(true)"
            @current-change="()=>getData()"
            :current-page.sync="pagination.currentPage"
            :page-sizes="[10,20,30,50]"
            :page-size.sync="pagination.pagesize"
            layout="slot, sizes, total, pager, prev, next"
            :total="pagination.total"
            popper-class="select-page-recharge"
          >
            <span style="color:#ffffff;padding-left:15px;">{{$t('device.pageSize')}} :</span>
          </el-pagination>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import subDialog from "@/components/dialognew";
export default {
  components: {
    subDialog
  },
  data () {
    return {
      // 订阅列表
      subscribeList: [
        {
          rule: '规则1',
          emailTitle: '日报表【2021.01.01】',
          device: 'A60000204200417237',
          email: '1@163.com',
          type: '日报表',
          dimension: '每日',
          startTime: '2021.01.01',
          sendTime: '2021.01.02',
          language: '跟随系统',
        }
      ],
      emptyText: false,
      // 搜索内容
      inputText: '',
      // 搜索弹出
      showSearch: false,
    }
  }
}
</script>
<style lang="less" scoped>
.subscribe {
  display: flex;
  flex: 1;
  flex-direction: column;
  margin: 20px;
  overflow: auto;

  // background-color: rgb(34, 45, 53);
  .current-box {
    flex: 1;
    background: rgba(34, 45, 53, 1);
  }

  .history-box {
    flex: 1;
    margin-top: 20px;
    background: rgba(34, 45, 53, 1);
  }

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    box-shadow: none;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);

      .label-top {
        flex: 1;
        padding-left: 20px;
        color: rgba(235, 235, 235, 1);
        font-weight: bold;
        font-size: 18px;
      }

      .button-search {
        background: transparent;
        color: @primaryTextColor;
        border: none;
      }

      .search-alert {
        display: flex;
        justify-content: space-between;
        flex: 1;
        background: rgb(34, 45, 53);

        .search-hide {
          display: inline-block;
          width: 60px;
          height: 47px;
          line-height: 47px;
          text-align: center;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 47px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: 0px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          top: 4px;
          right: 0px;
        }

        /deep/.el-icon-circle-close:before {
          content: '';
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../../assets/img/general/Icon_Close_Dark.png);
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
        }
      }

      .button-export {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 16px;
        height: 48px;
        // background: var(--theme-color);
        background: @primaryTextColor;
        color: rgb(34, 45, 53);
        font-size: 14px;
        cursor: pointer;

        .ico-add {
          background: url(../../../assets/img/general/Icon_Export_Add.png);
        }

        .ico-clear {
          background: url(../../../assets/img/general/Icon_Export_Clear.png);
        }

        .ico-base {
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 10px
        }
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }
    }

    .tablebottom {
      // text-align:center;
      display: flex;
      justify-content: space-between;
      // margin-bottom: 10px;
      border-top: 1px solid rgba(198, 209, 221, 0.5);
      ;

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        // align-self: flex-start;
        padding: 0;
        margin: 0;
        // margin-top: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
          border: none;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
        }

        /deep/.el-pager li:not(.disabled).active {
          background: #15C491;
          color: #ffffff;
        }

        /deep/.el-pager li:not(.disabled):not(.active):hover {
          color: #15C491;
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // /deep/.el-pagination button:disabled {
        //   background-color: #2B3842;
        //   color: #7B8395;
        // }
        // /deep/.el-pagination button, 
        // /deep/.el-pagination span:not([class*=suffix]) {
        //   height: 48px;
        //   line-height: 48px;
        // }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        color: #15C491;
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0px;
    height: 0px;
    background-color: #222d35;
  }
}
</style>